import React, { useState, useMemo, useEffect } from "react";
import "./shortcuts.scss";
import Reactportal from "../Admin/Components/Reactportal/Reactportal";
import PortalFooter from "../Admin/Components/Reactportal/PortalFooter";
import { useModalContext } from "../Admin/Components/Reactportal/ModalContext";
import { myShortcuts } from "./myShortcuts";


export const MyCustomShortcutSheet = ({ isOpen, onClose }) => {
  const TypeOfPortal = "Keyboard Shortcuts";
  const { pushModal, popModal, setSettings, settings } = useModalContext();
  const [searchValue, setSearchValue] = useState("");
  // const [visibleKeys, setVisibleKeys] = useState(true);
  // const [enableShortcuts, setEnableShortcuts] = useState(true);

  const Form_Key = "Shortcut_Keys";
  // Filter shortcuts by search text (case-insensitive)

  // Convert the object myShortcuts into an array and filter based on searchValue
  const filteredShortcuts = useMemo(() => {
    // Convert myShortcuts object into an array of shortcuts.
    const allShortcuts = Object.entries(myShortcuts).map(([key, shortcut]) => ({
      id: key, // using the property key as the unique identifier
      title: shortcut.name,
      // Split the keyCombo string to get an array of key labels.
      keys: shortcut?.keyCombo?.split("+").map((k) => k.trim()),
      description: shortcut.description,
    }));

    // Filter shortcuts by search text (case-insensitive)
    const lowerSearch = searchValue.toLowerCase();
    return allShortcuts.filter(
      (sc) =>
        sc.title.toLowerCase().includes(lowerSearch) ||
        sc.description.toLowerCase().includes(lowerSearch) ||
        sc.keys.some((key) => key.toLowerCase().includes(lowerSearch))
    );
  }, [searchValue]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  const footerContent = (
    <PortalFooter
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      handleformclose={() => {
        onClose();
      }}
    />
  );

  return (
    <Reactportal open={isOpen} onClose={onClose} FoooterContent={footerContent} TypeOfPortal={TypeOfPortal}>
      {/* Modal Content */}
      <>
        <div className="my-shortcut-sheet-content">
          {/* Filter area: search bar + checkboxes */}
          <div className="my-shortcut-sheet-filters">
            <div className="my-shortcut-sheet-search-container">
              <input
                className="my-shortcut-sheet-search"
                type="search"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="Search shortcuts..."
              />
            </div>

            <div className="my-shortcut-sheet-checkboxes">
              <label>
                <input
                  type="checkbox"
                  checked={settings.visable_keys}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      visable_keys: e.target.checked,
                    })
                  }
                />
                Visible Keys
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={settings.enableshortcuts}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      enableshortcuts: e.target.checked,
                    })
                  }
                />
                Enable Shortcuts
              </label>
            </div>
          </div>

          {/* Shortcut list */}
          <div className="my-shortcut-sheet-list">
            {!filteredShortcuts.length ? (
              <div className="my-shortcut-sheet-empty">
                <p>No shortcuts found.</p>
              </div>
            ) : (
              filteredShortcuts.map((shortcut) => (
                <div
                  key={shortcut.id}
                  className={`my-shortcut-sheet-card`}
                >
                  <div className="my-shortcut-sheet-card-header">
                    <h3 className="my-shortcut-sheet-card-title">{shortcut.title}</h3>
                  </div>
                  <div className="my-shortcut-sheet-card-description">{shortcut.description}</div>
                  <div className="my-shortcut-sheet-card-footer">
                    { (
                      <div className="my-shortcut-sheet-key-combo">
                        {shortcut.keys.map((key, index) => (
                          <React.Fragment key={`${shortcut.id}-${key}`}>
                            <span className="my-shortcut-sheet-key">{key}</span>
                            {index < shortcut.keys.length - 1 && <span className="my-shortcut-sheet-key-plus">+</span>}
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </>
    </Reactportal>
  );
};
